import React from "react";

export default function Support(props) {
  return <div>{`Support for ${props.appName}`}</div>;
}
